// Configuration du service analytics
export const ANALYTICS_CONFIG = {
  // Endpoint API pour envoyer les événements
  endpoint: process.env.REACT_APP_ANALYTICS_ENDPOINT || '/api/analytics/events',

  // Mode debug - affiche les événements dans la console
  debug: process.env.NODE_ENV === 'development',

  // Activer/désactiver le tracking globalement
  enabled: process.env.REACT_APP_ANALYTICS_ENABLED !== 'false',

  // Configuration du batching
  batchSize: 10,              // Nombre d'événements avant flush automatique
  flushIntervalMs: 5000,      // Intervalle de flush en ms

  // Configuration de session
  sessionTimeoutMs: 30 * 60 * 1000, // 30 minutes d'inactivité = nouvelle session

  // Seuils pour les micro-comportements
  hesitationThresholdMs: 5000,  // Focus sans saisie > 5s = hésitation
  longFocusThresholdMs: 30000,  // Focus > 30s = potentiel blocage

  // Tranches d'âge pour la segmentation
  ageRanges: [
    { min: 0, max: 17, label: '0-17' },
    { min: 18, max: 24, label: '18-24' },
    { min: 25, max: 34, label: '25-34' },
    { min: 35, max: 44, label: '35-44' },
    { min: 45, max: 54, label: '45-54' },
    { min: 55, max: 64, label: '55-64' },
    { min: 65, max: 999, label: '65+' }
  ]
};

// Helper pour obtenir la tranche d'âge
export const getAgeRange = (age) => {
  const range = ANALYTICS_CONFIG.ageRanges.find(r => age >= r.min && age <= r.max);
  return range ? range.label : 'unknown';
};

// Helper pour déterminer le type de device
export const getDeviceType = () => {
  const width = window.innerWidth;
  if (width < 768) return 'mobile';
  if (width < 1024) return 'tablet';
  return 'desktop';
};

// Helper pour catégoriser le referrer
export const getReferrerCategory = () => {
  const referrer = document.referrer;
  if (!referrer) return 'direct';

  try {
    const url = new URL(referrer);
    const host = url.hostname.toLowerCase();

    if (host.includes('google') || host.includes('bing') || host.includes('yahoo') || host.includes('duckduckgo')) {
      return 'search';
    }
    if (host.includes('facebook') || host.includes('twitter') || host.includes('linkedin') || host.includes('instagram')) {
      return 'social';
    }
    if (host.includes('aide-sociale.fr')) {
      return 'internal';
    }
    return 'referral';
  } catch {
    return 'unknown';
  }
};
